import { ColumnLabel, ColumnValue } from "./Columns";
import { Product } from "../../product";

export const ProductListUpdatedColumn = {
  name: ColumnValue.Updated,
  label: ColumnLabel[ColumnValue.Updated],
  renderCell: (p: Product): string =>
    p.updated_at && new Date(p.updated_at).toISOString().split("T")[0],
};
